import { useEffect, useState } from "react";

/**
 * Trả về `true` khi nên giảm hiệu ứng nặng (animation trang trí, glow nhấp nháy).
 *
 * Kích hoạt khi một trong các điều kiện sau đúng:
 * - User bật "Giảm chuyển động" của hệ điều hành (`prefers-reduced-motion`), hoặc
 * - Thiết bị yếu: RAM ≤ 2GB HOẶC (RAM ≤ 4GB VÀ ≤ 4 nhân CPU).
 *
 * `deviceMemory` chỉ có trên Chromium; thiếu thì coi như không phải máy yếu
 * (để tránh tắt nhầm trên Safari/iOS — vốn đã mạnh & có reduce-motion riêng).
 * SSR-safe: mặc định `false` cho tới khi đo được ở client.
 */
export function useReducedEffects(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const nav = navigator as Navigator & { deviceMemory?: number };
    const memory = typeof nav.deviceMemory === "number" ? nav.deviceMemory : undefined;
    const cores =
      typeof navigator.hardwareConcurrency === "number" ? navigator.hardwareConcurrency : undefined;

    const lowEnd =
      (memory !== undefined && memory <= 2) ||
      (memory !== undefined && memory <= 4 && cores !== undefined && cores <= 4);

    const update = () => setReduced(mql.matches || lowEnd);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return reduced;
}
